<template>
  <b-card class="check-activity-feed text-center">
    <h6><strong>Check your activity feed</strong></h6>
    <div class="check-img p-4">
      <b-img src="@/assets/images/check-green.png" />
    </div>
    <template #footer>
      <b-button variant="link" @click.prevent="$emit('dismiss')">
        Dismiss
      </b-button>
    </template>
  </b-card>
</template>

<script>
export default {
  name: 'CheckActivityFeed'
}
</script>
